import { api } from 'shared/api';
import { ApiError, ApiResponse } from 'shared/model/types';
import { UserAuth } from 'entities/user/model/types';
import { setLanguage } from 'shared/config/store/reducers/appSlice';
import { AVAILABLE_LANGUAGES, Language } from 'shared/const/languages';
// import { isSupportedLanguage } from 'shared/libs/i18n/helpers';
import { getErrorId } from 'shared/libs/helpers';
import { ERROR_IDS } from 'shared/const/api';
import { isSupportedLanguage } from 'shared/libs/intl/helpers';
import { setUserMeta } from 'shared/config/store/reducers/userSlice';

const loginApi = api.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<
      ApiResponse<UserAuth>,
      {
        email: string;
        password: string;
        google2faCodeFromUser?: string | number;
      }
    >({
      query: ({ email, password, google2faCodeFromUser }) => {
        const formData = new FormData();
        formData.append('email', email);
        formData.append('password', password);
        if (google2faCodeFromUser !== undefined) {
          formData.append('google2faCodeFromUser', String(google2faCodeFromUser));
        }
        return {
          url: '/auth/login',
          method: 'POST',
          body: formData,
        };
      },
      async onQueryStarted({ email, password }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled,
            rawLanguage = data.response.language;
          if (isSupportedLanguage(rawLanguage)) {
            dispatch(setLanguage(rawLanguage.toLowerCase() as Language));
          } else {
            dispatch(setLanguage(AVAILABLE_LANGUAGES.EN.id));
          }
          dispatch(api.util.resetApiState());
        } catch (e) {
          //@ts-expect-error try-catch
          const apiError = e?.error;

          if (apiError) {
            if (getErrorId(apiError as ApiError) === ERROR_IDS.TWO_FA_NOT_PROVIDED) {
              // navigate('TwoFactor', { email, password });
            }
          }
        }
      },
    }),
  }),
});
export const { useLoginMutation } = loginApi;
